<div class="risk-dialog" data-testid="risk-export-dialog">
  <div class="dialog-title flex justify-between items-start"><span>Export to Excel</span><button mat-icon-button (click)="dialogRef.close()" aria-label="Close"><mat-icon>close</mat-icon></button></div>
  <div class="label">Include</div>
  <div class="flex flex-row flex-wrap gap-[16px] mb-[20px]">@for (s of statuses; track s.value) { <mat-checkbox [(ngModel)]="s.on" color="primary">{{ s.label }}</mat-checkbox> }</div>
  @if (!data.isContractor) {
    <div class="label">Internal risks</div>
    <mat-radio-group [(ngModel)]="internal" class="flex flex-col gap-[8px] mb-[20px]" data-testid="export-internal">
      <mat-radio-button value="exclude" color="primary">Exclude (contractor copy)</mat-radio-button>
      <mat-radio-button value="include" color="primary">Include (full register)</mat-radio-button>
    </mat-radio-group>
  }
  <div class="text-type-14 mb-[8px]">Same columns as the import layout, plus one Trend / Update pair per update date, so it can be imported into the next project.</div>
  <div class="risk-dialog-actions flex flex-row gap-[16px] mt-[16px]">
    <app-secondary-button (handleClick)="dialogRef.close()" class="flex-1">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="download()" [isDisabled]="busy" [isLoading]="busy" class="flex-1" data-testid="export-download">Download .xlsx</app-primary-button>
  </div>
</div>
